/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import {
  Autocomplete,
  AutocompleteRenderOptionState,
  Box,
  Button as Button1,
  Checkbox,
  LinearProgress,
  Tooltip,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import addLogo from "../../../images/addLogo.png";
import "./CreateTenant.scss";
import DefaultProfileImgDark from "../../../images/DefaultProfileImgDark.png";
import {
  editTenantDetails,
  getAvailableCurrencies,
  getAvailableDataCenters,
  getAvailableProducts,
  getGeoMapping,
  getTenantLogo,
  uploadTenantLogoDetails,
} from "../../../store/Tenant/tenant-actions";
import {
  GeoMapping,
  IErrorProps,
  MappingCountry,
  MappingRegion,
  MappingState,
  OptionsProduct,
  OptionsTimeZone,
  OptionsUtilityType,
} from "../../../models";
import { AppDispatch, RootState } from "../../../store";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Loader from "../../Loader/Loader";
import IFile from "../../Image/types/File";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import updateErrorList from "../../../utils/methods/updateErrorList";
import { UTILITY_TYPES_OPTIONS } from "../../../utils/constants";
import { formatLatitudeForUI, formatLongitudeForUI, latitudeFromAPI, latitudeToAPI, longitudeFromAPI, longitudeToAPI, validateLatitude, validateLongitude } from "../../../utils/coordinateUtils";

import {
  Button,
  ControlError,
  Select,
  SelectOption,
  Input,
  Label,
  Chip,
  ChipRemove,
} from "@forge/common";
import { StepperProps } from "../../SetupTenant/createTenantDetails/CreateTenant";
import Footer from "../../SetupTenant/Footer/Footer";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import BreadCrumbsComponent from "../../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../../SharedComponents/Title/Title";
import useLocalStorageChange from "../../../hooks/useLocalStorageChange";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../../localization/keys";

const SELECT_ALL_PRODUCT = "Select All";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CreateEditTenantonBack: React.FC<StepperProps> = ({
  stepperState,
  setStepperState,
}) => {
  const [t] = useTranslation();
  const isInitialComponentRender = useRef(true);
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const backButtonHandler = () => {
    navigate("/tenant");
  };

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const [tenantNameDefaultValue, setTenantNameDefaultValue] =
    useState<string>("");
  const [headquarterAddressDefaultValue, setHeadquarterAddressDefaultValue] =
    useState<string>("");
  const [organizationNameDefaultValue, setOrganizationNameDefaultValue] =
    useState<string>("");
  const [organizationIdDefaultValue, setOrganizationIdDefaultValue] =
    useState<string>("");
  const [countryDefaultValue, setCountryDefaultValue] = useState<string>("");
  const [regionDefaultValue, setRegionDefaultValue] = useState<number>(0);
  const [stateDefaultValue, setStateDefaultValue] = useState<number>(0);
  const [zipcodeDefaultValue, setZipcodeDefaultValue] = useState<string>("");
  const [currencyDefaultValue, setCurrencyDefaultValue] = useState<string>("");
  const [dataCenterDefaultValue, setDataCenterDefaultValue] =
    useState<string>("");
  const [timezoneDefaultValue, setTimezoneDefaultValue] = useState<string>("");
  const [productDefaultValueList, setProductDefaultValueList] = useState<
    string[]
  >([]);
  const [
    productsConcatenatedInAsDefaultValue,
    setProductsConcatenatedInAsDefaultValue,
  ] = useState("");
  const [isFormDataChanged, setIsFormDataChanged] = useState<boolean>(false);

  const [regionMapping, setRegionMapping] = useState<Array<MappingRegion>>([]);
  const [countryMapping, setCountryMapping] = useState<Array<MappingCountry>>(
    []
  );
  const [stateMapping, setStateMapping] = useState<Array<MappingState>>([]);
  const [TimezoneMapping, setTimezoneMapping] = useState<
    Array<OptionsTimeZone>
  >([]);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  // Error lists
  const [errorGeoMapping, seterrorGeoMapping] = useState<Array<IErrorProps>>(
    []
  );
  const [enteredTenantName, setTenantName] = useState("");

  const [enteredheadquarterAddress, setheadquarterAddress] = useState("");
  const [enteredOrganizationName, setOrganizationName] = useState("");
  const [enteredOrganizationId, setOrganizationId] = useState("");
  const [enteredTimeZone, setTimeZone] = useState("");
  const [enteredDatacenter, setDataCenter] = useState("");
  const [enteredProduct, setProduct] = React.useState<OptionsProduct[]>([]);
  const [enteredProductSubmit, setProductSumbit] = React.useState<string[]>([]);
  const [tenanthasError, settenanthasError] = useState(false);
  const [AddresshasError, setAddresshasError] = useState(false);
  const [enteredCurrency, setCurrency] = useState("");
  const [tenantID, setTenantID] = useState("");
  const [currentImage, setCurrentImage] = useState<File>();
  const [previewImage, setPreviewImage] = useState<string>("");
  const [progress, setProgress] = useState<number>(0);
  const [message, setMessage] = useState<string>("");
  const [imageInfos, setImageInfos] = useState<Array<IFile>>([]);
  const [tenantCurrentLogo, setCurrentTenantLogo] = useState<string>("");
  const [enteredCountry, setCountry] = useState("");
  const [enteredRegion, setRegion] = useState("");
  const [enteredState, setState] = useState("");
  const [zipcodehasError, setZipcodehasError] = useState<boolean>(false);
  const [enteredZipcode, setZipcode] = useState("");
  const [allSelected, setAllSelected] = useState(false);

  const [enteredUtilityType, setUtilityType] = useState<OptionsUtilityType[]>([]);
  const [enteredUtilityTypeSubmit, setUtilityTypeSubmit] = useState<string[]>([]);
  const [utilityTypeConcatenatedInAsDefaultValue, setUtilityTypeConcatenatedInAsDefaultValue] = useState("");
  const [allSelectedUT, setAllSelectedUT] = useState(false);
  const [showAllUT, setShowAllUT] = useState(false);

  const [enteredLatitude, setLatitude] = useState("");
  const [latitudehasError, setLatitudehasError] = useState<boolean>(false);
  const [latitudeDefaultValue, setLatitudeDefaultValue] = useState<number>(0);
  const [enteredLongitude, setLongitude] = useState("");
  const [longitudehasError, setLongitudehasError] = useState<boolean>(false);
  const [longitudeDefaultValue, setLongitudeDefaultValue] = useState<number>(0);

  const [enteredStreet, setStreet] = useState("");
  const [enteredCity, setCity] = useState("");
  const [addressHasError, setAddressHasError] = useState<{ street?: boolean; city?: boolean; zipcode?: boolean }>({});

  const optionsGeoMapping: GeoMapping = useSelector(
    (state: RootState) => state.cart.geoMapping
  );

  const [isCountryDisabled, setIsCountryDisabled] = useState(false);
  const [isStateDisabled, setIsStateDisabled] = useState(false);

  const [isTimeZoneDisabled, setIsTimeZoneDisabled] = useState(false);
  const [stateForDropDownCountryMapping, setStateForDropDownCountryMapping] =
    useState(1);
  const [stateForDropDownStateMapping, setStateForDropDownStateMapping] =
    useState(1);
  const [stateForDropDownTimeZoneMapping, setStateForDropDownTimeZoneMapping] =
    useState(1);
  const [showAll, setShowAll] = useState(false);

  const optionsDataCenter = useSelector(
    (state: RootState) => state.cart.availableDataCentres
  );
  let prodOptions: OptionsProduct[] = [
    { productId: SELECT_ALL_PRODUCT, settings: [], productName: SELECT_ALL_PRODUCT },
  ];
  const optionsProduct = prodOptions.concat(
    useSelector((state: RootState) => state.cart.availableProducts)
  );
  const optionsProductFromStore = useSelector(
    (state: RootState) => state.cart.availableProducts
  );

  let utOptions: OptionsUtilityType[] = [
    { id: SELECT_ALL_PRODUCT, name: SELECT_ALL_PRODUCT },
  ];
  const optionsUtilityType = utOptions.concat(UTILITY_TYPES_OPTIONS);
  const optionsUtilityTypeFromStore = UTILITY_TYPES_OPTIONS;

  const optionsCurrency = useSelector(
    (state: RootState) => state.cart.availableCurrencies
  );

  const [theme, setCurrentTheme] = useState(
    localStorage.getItem("currentTheme") || "light"
  );

  useLocalStorageChange("currentTheme", (updatedTheme: any) => {
    if (updatedTheme) {
      setCurrentTheme(updatedTheme);
    }
  });

  // All useState are for dropdown "key" field
  useEffect(() => {
    setStateForDropDownCountryMapping(stateForDropDownCountryMapping + 1);
  }, [countryMapping, enteredCountry]);
  useEffect(() => {
    setStateForDropDownStateMapping(stateForDropDownStateMapping + 1);
  }, [enteredCountry]);
  useEffect(() => {
    setStateForDropDownTimeZoneMapping(stateForDropDownTimeZoneMapping + 1);
  }, [enteredRegion, TimezoneMapping]);
  // TODO: need to recalculate based on GeoMapping data

  const TenantNameRegex = /^[a-zA-Z\s]*$/; // Only allows alphanumeric characters
  const AddressRegex = /^[a-zA-Z0-9,\s\.\-]*$/; // Only allows alphanumeric charactersconst getCountryNameById = (id: string): string | undefined => {
  const isUpdated = useRef({
    tenantName: false,
    headquarterAddress: false,
    organizationName: false,
    organizationId: false,
    region: false,
    stateValue: false,
    country: false,
    zipcode: false,
    tenantDataCenter: false,
    products: false,
    utilityType: false,
    currency: false,
    timezone: false,
    latitude: false,
    longitude: false,
    profilePic: false,
  });
  // istanbul ignore next
  // Get region By Id
  const getRegionById = (RegionId: string): string | undefined => {
    const region = regionMapping.find((c) => c.id === +RegionId);
    return region?.name;
  };

  const onBackBtn = () => {
    if (tenantDetails?.status === "SetupCompleted") {
      navigate(-1);
    }
    //#TODO - check if we need to navigate to tenant/user and fetch before tenant details we navigate
  };
  useEffect(() => {
    let x1 = optionsGeoMapping.countryDataMap.findIndex(
      (x) => x.country.id === +enteredCountry
    );
    let state: Array<MappingState> = [];

    if (x1 !== -1 && +enteredCountry === 1) {
      setIsStateDisabled(false);
      state = optionsGeoMapping.countryDataMap[x1].states;
      setStateMapping(state);
    } else {
      setIsStateDisabled(true);
    }
  }, [enteredCountry]);

  useEffect(() => {
    const newregionMapping: Array<MappingRegion> = [];
    optionsGeoMapping.regionDataMap.map((x) => {
      newregionMapping.push(x.region);
    });
    setRegionMapping(newregionMapping);
  }, [optionsGeoMapping]);

  useEffect(() => {
    let indexOfRegionData = optionsGeoMapping.regionDataMap.findIndex(
      (x) => x.region.id === +enteredRegion
    );

    let countries: Array<MappingCountry> = [];
    let timezone: Array<OptionsTimeZone> = [];
    // istanbul ignore next
    //for geomapping region finder
    if (indexOfRegionData !== -1) {
      countries = optionsGeoMapping.regionDataMap[indexOfRegionData].countries;
      timezone = optionsGeoMapping.regionDataMap[indexOfRegionData].timezones;

      setCountryMapping(countries);
      setTimezoneMapping(timezone);
    }
  }, [enteredRegion]);

  useEffect(() => {
    let x1 = optionsGeoMapping.countryDataMap.findIndex(
      (x) => x.country.id === +enteredCountry
    );
    let state: Array<MappingState> = [];
    // istanbul ignore next
    //for geomapping country finder
    if (x1 !== -1) {
      state = optionsGeoMapping.countryDataMap[x1].states;
      setStateMapping(state);
    }
  }, [enteredCountry]);

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  // const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  // const errorRef = useRef<Array<IErrorProps>>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [openDialogforConflict, setopenDialogforConflict] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  const onDialogForConflictCloseHandler = () => {
    setopenDialogforConflict(false);
    navigate("/tenant");
  };

  //////////////Error Handling////////////////////////

  // API calls
  // Get Datacentres if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableDataCenters())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  // Get Geo mapping
  useEffect(() => {
    if (optionsGeoMapping.countryDataMap.length === 0) {
      setIsLoading(true);
      dispatch(getGeoMapping())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorGeoMapping(updateErrorList(error, [...errorGeoMapping]));
        })
        .finally(() => setIsLoading(false));
    }
  }, [optionsGeoMapping]);
  // Get currencies if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableCurrencies())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);
  // Get available products if not present
  useEffect(() => {
    if (optionsProduct?.length === 1) {
      // 1 because Select All is optionally added by default
      setIsLoading(true);
      dispatch(getAvailableProducts())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  // istanbul ignore next
  //Update for button disabled
  const handleUpdateBtnDisable = (
    defaultValue: any,
    newValue: any,
    fieldModified:
      | "tenant"
      | "headqtrAdd"
      | "organizationName"
      | "organizationId"
      | "region"
      | "country"
      | "state"
      | "zipCode"
      | "datacenter"
      | "product"
      | "utilityType"
      | "currency"
      | "timeZone"
      | "latitude"
      | "longitude"
  ) => {
    const valueUpdated = checkIfValueCHanged(
      defaultValue === undefined || defaultValue === null ? "" : defaultValue,

      newValue === undefined || newValue === null ? "" : newValue
    );
    switch (fieldModified) {
      case "tenant":
        isUpdated.current = { ...isUpdated.current, tenantName: valueUpdated };
        break;

      case "headqtrAdd":
        isUpdated.current = {
          ...isUpdated.current,
          headquarterAddress: valueUpdated,
        };
        break;
      case "organizationName":
        isUpdated.current = { ...isUpdated.current, organizationName: valueUpdated };
        break;
      case "organizationId":
        isUpdated.current = { ...isUpdated.current, organizationId: valueUpdated };
        break;
      case "region":
        isUpdated.current = { ...isUpdated.current, region: valueUpdated };
        break;
      case "country":
        isUpdated.current = { ...isUpdated.current, country: valueUpdated };
        if (newValue !== "1") {
          isUpdated.current = { ...isUpdated.current, stateValue: false };
        }
        break;
      case "state":
        isUpdated.current = { ...isUpdated.current, stateValue: valueUpdated };
        break;
      case "zipCode":
        isUpdated.current = { ...isUpdated.current, zipcode: valueUpdated };
        break;
      case "datacenter":
        isUpdated.current = {
          ...isUpdated.current,
          tenantDataCenter: valueUpdated,
        };
        break;
      case "product":
        isUpdated.current = { ...isUpdated.current, products: valueUpdated };
        break;
      case "currency":
        isUpdated.current = { ...isUpdated.current, currency: valueUpdated };
        break;
      case "timeZone":
        isUpdated.current = { ...isUpdated.current, timezone: valueUpdated };
        break;
      case "utilityType":
        isUpdated.current = { ...isUpdated.current, utilityType: valueUpdated };
        break;
      case "latitude":
        isUpdated.current = { ...isUpdated.current, latitude: valueUpdated };
        break;
      case "longitude":
        isUpdated.current = { ...isUpdated.current, longitude: valueUpdated };
        break;
      default:
        // Handle unknown field modification or provide a default case
        break;
    }
    const isAnyValueTrue = Object.values(isUpdated.current).some(
      (value) => value
    );

    if (isAnyValueTrue) {
      setIsFormDataChanged(true);
    } else {
      setIsFormDataChanged(false);
    }
  };
  const tenantDetails = useSelector(
    (state: RootState) => state.cart.tenantDeatailsByTenantId
  );
  useEffect(() => {
    if (isInitialComponentRender.current) {
      var currency = optionsCurrency?.filter(function (item) {
        return item.name == tenantDetails?.currency;
      });

      var dataCenter = optionsDataCenter.filter(function (item) {
        return item.name == tenantDetails?.datacenter;
      });

      var timeZone = TimezoneMapping?.filter(function (item) {
        return item.name == tenantDetails?.timezone;
      });

      var country = countryMapping?.filter(function (item) {
        return item.name == tenantDetails?.address?.country;
      });

      var region = regionMapping?.filter(function (item) {
        return item.name == tenantDetails?.region;
      });
      var state = stateMapping?.filter(function (item) {
        return item.name == tenantDetails?.address?.state;
      });

      var product = optionsProduct?.filter(function (productSelected) {
        return tenantDetails?.products?.some(
          (prod: { productId: string }) =>
            prod.productId === productSelected.productId
        );
      });

      setTenantName(tenantDetails?.tenantName);
      setTenantNameDefaultValue(tenantDetails?.tenantName);
      setheadquarterAddress(tenantDetails?.headquarterAddress ?? "");
      setHeadquarterAddressDefaultValue(
        tenantDetails?.headquarterAddress ?? ""
      );
      setOrganizationName(tenantDetails?.organizationName ?? "");
      setOrganizationNameDefaultValue(tenantDetails?.organizationName ?? "");
      setOrganizationId(tenantDetails?.organizationId ?? "");
      setOrganizationIdDefaultValue(tenantDetails?.organizationId ?? "");

      setTenantID(tenantDetails?.tenantId);
      setTenantNameDefaultValue(tenantDetails?.tenantName);
      setZipcode(tenantDetails?.address?.zipcode?.toString() ?? "");
      setZipcodeDefaultValue(tenantDetails?.address?.zipcode?.toString() ?? "");
      setStreet(tenantDetails?.address?.street ?? "");
      setCity(tenantDetails?.address?.city ?? "");

      const latitudeValue = tenantDetails?.latitude ? latitudeFromAPI(tenantDetails.latitude) : "";
      const longitudeValue = tenantDetails?.longitude ? longitudeFromAPI(tenantDetails.longitude) : "";
      setLatitude(latitudeValue);
      setLongitude(longitudeValue);

      // setTenantID((params as any).id);
      // istanbul ignore next

      if (country?.length > 0) {
        setCountry(country[0].id.toString());
        setCountryDefaultValue(country[0].id.toString());
        if (country[0].id.toString() === "1" && stateMapping.length > 0) {
          setState(state[0]?.id.toString());
          setStateDefaultValue(state[0]?.id);
          setStateForDropDownStateMapping(stateForDropDownStateMapping + 1);
        }
      }
      // istanbul ignore next
      //for geomapping region
      if (region?.length > 0) {
        setRegion(region[0].id as unknown as string);
        setRegionDefaultValue(region[0].id);
      }
      // istanbul ignore next
      //for  datatcenter setup
      if (dataCenter?.length > 0) {
        setDataCenter(dataCenter[0].id);
        setDataCenterDefaultValue(dataCenter[0].id);
      }
      // istanbul ignore next
      //for   setup timezone
      if (timeZone?.length > 0) {
        setTimeZone(timeZone[0].id);
        setTimezoneDefaultValue(timeZone[0].id);
      }
      // istanbul ignore next
      //for  currency setup
      if (currency?.length > 0) {
        setCurrency(currency[0].id);
        setCurrencyDefaultValue(currency[0].id.toString());
      }
      // Option Product by default has " Select All" value.
      // So, we need to check if its more than 1.For others its more than 0
      // istanbul ignore next
      if (
        product !== null &&
        product !== undefined &&
        optionsProductFromStore?.length > 0
      ) {
        setProduct(product);
        setProductDefaultValueList(
          product.map((productDef) => productDef.productId)
        );
        setProductsConcatenatedInAsDefaultValue(
          product
            .map((x) => x.productId)
            .sort()
            .join("_")
        );
      }
      // For utilityType setup
      // istanbul ignore next
      var utilityType = optionsUtilityType?.filter(function (utilityTypeSelected) {
        const utilityTypeValues = (tenantDetails?.utilityType || "")
          .split(",")
          .map((item: string) => item.trim())
          .filter(Boolean)
          .map((item: string) => ({
            id: item,
            name: item.charAt(0).toUpperCase() + item.slice(1)
          }));
        return utilityTypeValues.some((ut: { id: string }) => ut.id === utilityTypeSelected.id);
      });
      if (utilityType !== null && utilityType !== undefined && optionsUtilityTypeFromStore?.length > 0) {
        setUtilityType(utilityType);
        setUtilityTypeConcatenatedInAsDefaultValue(
          utilityType.map((x: OptionsUtilityType) => x.id).sort().join("_")
        );
      }
    }
  }, [
    optionsDataCenter,
    optionsCurrency,
    optionsProductFromStore,
    countryMapping,
    regionMapping,
    TimezoneMapping,
    stateMapping,
  ]);

  useEffect(() => {
    if (tenantID === "") {
    } else {
      setIsLoading(true);
      dispatch(getTenantLogo(tenantID))
        .unwrap()
        .then((response: any) => {
          setCurrentTenantLogo(response as string);
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, [tenantID]);

  useEffect(() => {
    setProductSumbit(
      optionsProduct
        .filter(function (n) {
          return enteredProduct.indexOf(n) !== -1;
        })
        .map((x) => x.productId)
    );
  }, [enteredProduct]);

  useEffect(() => {
    setUtilityTypeSubmit(
      optionsUtilityType
        .filter((n) => enteredUtilityType.indexOf(n) !== -1)
        .map((x) => x.id)
    );
  }, [enteredUtilityType]);

  const [errors, setErrors] = useState({
    custName: "",
    address1: "",
    timezone: "",
    datacenter: "",
    currency: "",
    // applications: "",
    // forgeId: "",
    tenantId: "",
    country: "",
    region: "",
    state: "",
  });

  const params = useParams();

  // const TenantNameChangeHandler = (event: any) => {
  //   isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
  //   setTenantName(event.target.value);
  //   if (TenantNameRegex.test(event.target.value)) {
  //     settenanthasError(false);
  //   } else {
  //     settenanthasError(true);
  //   }
  //   handleUpdateBtnDisable(
  //     tenantNameDefaultValue,
  //     event.target.value.toString(),
  //     "tenant"
  //   );
  // };

  // istanbul ignore next
  const headquarterAddressChangeHandler = (event: any) => {
    setheadquarterAddress(event.target.value);
    if (AddressRegex.test(event.target.value)) {
      setAddresshasError(false);
    } else {
      setAddresshasError(true);
    }
    handleUpdateBtnDisable(
      headquarterAddressDefaultValue,
      event.target.value.toString(),
      "headqtrAdd"
    );
  };

  // istanbul ignore next
  const organizationNameChangeHandler = (event: any) => {
    setOrganizationName(event.target.value);
    handleUpdateBtnDisable(
      organizationNameDefaultValue,
      event.target.value.toString(),
      "organizationName"
    );
  };

  // istanbul ignore next
  const organizationIdChangeHandler = (event: any) => {
    setOrganizationId(event.target.value);
    handleUpdateBtnDisable(
      organizationIdDefaultValue,
      event.target.value.toString(),
      "organizationId"
    );
  };

  // istanbul ignore next
  const dataCenterChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setDataCenter(event.target.value);

    handleUpdateBtnDisable(
      dataCenterDefaultValue.toString(),
      event.target.value.toString(),
      "datacenter"
    );
  };

  // istanbul ignore next
  const currencyChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setCurrency(event.target.value);
    handleUpdateBtnDisable(
      currencyDefaultValue,
      event.target.value.toString(),
      "currency"
    );
  };

  // istanbul ignore next
  const TimezoneChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setTimeZone(event.target.value);
    handleUpdateBtnDisable(
      timezoneDefaultValue,
      event.target.value.toString(),
      "timeZone"
    );
  };

  // istanbul ignore next
  const countryChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setCountry(event.target.value);
    setStateDefaultValue(0);
    setState("");
    handleUpdateBtnDisable(
      countryDefaultValue,
      event.target.value.toString(),
      "country"
    );
  };

  // istanbul ignore next
  const regionChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setRegion(event.target.value);
    // Enable country field after selecting "Region" field
    setCountryDefaultValue("");
    setIsCountryDisabled(false);
    setIsTimeZoneDisabled(false);
    setCountry("");
    setTimeZone("");
    setState("");
    handleUpdateBtnDisable(
      regionDefaultValue.toString(),
      event.target.value.toString(),
      "region"
    );
    // if (
    //   event.target.value.toString() !==
    //   location?.state?.editTenantDetails?.region
    // ) {
    //   setIsFormDataChanged(true);
    // }
  };

  // istanbul ignore next
  const stateChangeHandler = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setState(event.target.value);
    handleUpdateBtnDisable(
      stateDefaultValue.toString(),
      event.target.value.toString(),
      "state"
    );
  };

  // istanbul ignore next
  const ZipcodeChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequent renders
    setZipcode(event.target.value);
    const regexpassed: RegExp = /^[a-zA-Z0-9s-]{3,15}$/;
    if (regexpassed.test(event.target.value)) {
      setZipcodehasError(false);
    } else {
      setZipcodehasError(true);
    }

    handleUpdateBtnDisable(
      zipcodeDefaultValue,
      event.target.value.toString(),
      "zipCode"
    );
  };

  // istanbul ignore next
  const StreetAddressChangeHandler = (event: any) => {
    isInitialComponentRender.current = false;
    setStreet(event.target.value);
    setAddressHasError((prev: any) => ({ ...prev, street: false }));
  };

  // istanbul ignore next
  const CityChangeHandler = (event: any) => {
    isInitialComponentRender.current = false;
    setCity(event.target.value);
    setAddressHasError((prev: any) => ({ ...prev, city: false }));
  };

  // istanbul ignore next
  const LatitudeChangeHandler = (event: any) => {
    isInitialComponentRender.current = false;
    const formattedValue = formatLatitudeForUI(event.target.value);
    setLatitude(formattedValue);
    setLatitudehasError(formattedValue !== "" && !validateLatitude(formattedValue));
    handleUpdateBtnDisable(latitudeDefaultValue, event.target.value.toString(), "latitude");
  };

  // istanbul ignore next
  const LongitudeChangeHandler = (event: any) => {
    isInitialComponentRender.current = false;
    const formattedValue = formatLongitudeForUI(event.target.value);
    setLongitude(formattedValue);
    setLongitudehasError(formattedValue !== "" && !validateLongitude(formattedValue));
    handleUpdateBtnDisable(longitudeDefaultValue, event.target.value.toString(), "longitude");
  };

  // istanbul ignore next
  const handleUtilityTypeSelection = (
    event: React.ChangeEvent<{}>,
    selectedOptions: OptionsUtilityType[]
  ) => {
    if (!selectedOptions || !optionsUtilityType) return;
    isInitialComponentRender.current = false;
    let selectedOptionValues: string[] = [];
    if (selectedOptions.find((option) => option.id === SELECT_ALL_PRODUCT)) {
      if (selectedOptions.length === optionsUtilityType.length) {
        setUtilityType([]);
        setAllSelectedUT(false);
      } else {
        setUtilityType(optionsUtilityType.slice(1));
        setAllSelectedUT(true);
      }
    } else {
      if (selectedOptions.length === optionsUtilityType.length - 1) {
        setAllSelectedUT(true);
      } else {
        setAllSelectedUT(false);
      }
      setUtilityType(selectedOptions);
      if (selectedOptions.length > 0) {
        selectedOptionValues = selectedOptions.map((option) => option.id);
      }
    }
    let newUtilityTypeConcatenatedValues = selectedOptionValues.sort().join("_");
    if (selectedOptions.length >= 0 && selectedOptions.map((x) => x.id).some((y) => y === SELECT_ALL_PRODUCT)) {
      newUtilityTypeConcatenatedValues = optionsUtilityType
        .filter((x) => x.id !== SELECT_ALL_PRODUCT)
        .map((y) => y.id)
        .sort()
        .join("_");
    }
    handleUpdateBtnDisable(utilityTypeConcatenatedInAsDefaultValue, newUtilityTypeConcatenatedValues, "utilityType");
  };

  // istanbul ignore next
  const onDeleteUtilityType = (id: any) => () => {
    const newSelectedUT = enteredUtilityType.filter((ut) => ut.id !== id);
    setUtilityType(newSelectedUT);
    setAllSelectedUT(false);
    handleUpdateBtnDisable(
      utilityTypeConcatenatedInAsDefaultValue,
      newSelectedUT.map((x) => x.id).sort().join("_"),
      "utilityType"
    );
  };

  const renderLimitedSelectedUtilityTypeTags = () => {
    if (!enteredUtilityType) return;
    const firstTwoTags = enteredUtilityType.slice(0, 2).map((v: OptionsUtilityType) => (
      <Chip key={v.id} className="theme-chip mb-1">
        {v.name}
        <ChipRemove onClick={onDeleteUtilityType(v.id)} className="theme-chip-remove">
          {v.name}
        </ChipRemove>
      </Chip>
    ));
    return firstTwoTags.concat(
      <Chip className="theme-chip theme-chip-limit-tag" key="limit" onClick={() => setShowAllUT(true)}>
        {`+${enteredUtilityType.length - 2}`}
      </Chip>
    );
  };

  const renderAllSelectedUtilityTypeTags = () => {
    return enteredUtilityType.map((v: OptionsUtilityType) => (
      <Chip key={v.id} className="theme-chip mb-1">
        {v.name}
        <ChipRemove onClick={onDeleteUtilityType(v.id)} className="theme-chip-remove">
          {v.name}
        </ChipRemove>
      </Chip>
    ));
  };
  //   setStepperState({
  //     ...stepperState,
  //     currentStep: "Settings",
  //     steps: stepperState.steps.map((step) => {
  //       if (step.id === "EditTenant") {
  //         return { ...step, status: "valid" };
  //       }
  //       return step;
  //     }),
  //   });
  // };
  // Handle application selection
  // istanbul ignore next

  const handleApplicationSelection = (
    event: React.ChangeEvent<{}>,
    selectedOptions: OptionsProduct[]
  ) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    let selectedOptionValues: string[] = [];
    if (selectedOptions.find((option) => option.productId == SELECT_ALL_PRODUCT)) {
      if (selectedOptions.length == optionsProduct.length) {
        setProduct([]);
        setAllSelected(false);
      } else {
        setProduct(optionsProduct.slice(1));
        setAllSelected(true);
      }
    } else {
      if (selectedOptions.length == optionsProduct.length - 1) {
        setAllSelected(true);
      } else {
        setAllSelected(false);
      }
      setProduct(selectedOptions);
      /**To disable update button incase of no change in products selection */

      if (selectedOptions && selectedOptions.length > 0) {
        selectedOptionValues = selectedOptions.map(
          (option) => option.productId
        );
      }
    }
    //#region Create newProductsConcatenatedValues
    let newProductsConcatenatedValues = selectedOptionValues.sort().join("_");
    if (
      selectedOptions.length >= 0 &&
      selectedOptions.map((x) => x.productId).some((y) => y == SELECT_ALL_PRODUCT)
    ) {
      newProductsConcatenatedValues = optionsProduct
        .filter((x) => x.productId !== SELECT_ALL_PRODUCT)
        .map((y) => y.productId)
        .sort()
        .join("_");
      // Make select All to applicationId concatenanted string
    }
    //#endregion

    handleUpdateBtnDisable(
      productsConcatenatedInAsDefaultValue,
      newProductsConcatenatedValues,
      "product"
    );
  };

  // istanbul ignore next
  // Check if the fields are filled
  // with input text
  const checkIfAnyTextFilled = () => {
    if (
      enteredTenantName === "" &&
      enteredheadquarterAddress === "" &&
      enteredCurrency === "" &&
      enteredDatacenter === "" &&
      // enteredProduct === []  &&
      enteredTimeZone === "" &&
      enteredCountry === "" &&
      enteredRegion === "" &&
      zipcodehasError === true
    )
      return true;
    else return false;
  };

  function goToSettingsPage() {
    setStepperState({
      ...stepperState,
      //  currentStep: "EditTenant",
      currentStep: "Settings",
      steps: stepperState.steps.map((step) => {
        if (step.id === "CreateTenant") {
          return { ...step, status: "valid" };
        }
        return step;
      }),
    });
  }
  // istanbul ignore next
  // Handle submit
  function onSubmitHandeller() {
    //event.preventDefault();

    setCreateOpen(false);
    if (
      !validate() ||
      enteredProductSubmit.length === 0 ||
      AddresshasError ||
      tenanthasError
    )
      return;
    let tenantId = tenantDetails.tenantId;
    let zipCodeOfTenant = enteredZipcode as string;

    const tenantToEdit: any = {
      //tenantName: enteredTenantName,
      headquarterAddress: enteredheadquarterAddress, // OK
      organizationName: enteredOrganizationName || "",
      organizationId: enteredOrganizationId || "",
      timezone: enteredTimeZone,
      datacenter: +enteredDatacenter as unknown as number, // number
      currency: +enteredCurrency,
      region: +enteredRegion as unknown as number,
      address: {
        street: enteredStreet || "",
        city: enteredCity || "",
        country: enteredCountry !== "" ? (+enteredCountry as unknown as number) : "",
        zipcode: zipCodeOfTenant,
        state:
          enteredCountry === "1" && enteredState !== ""
            ? +enteredState
            : "",
      },
      products: enteredProductSubmit, // array
      version: tenantDetails.version,
      status: tenantDetails.status,
    };
    if (enteredUtilityTypeSubmit.length > 0) {
      tenantToEdit.utilityType = enteredUtilityTypeSubmit.join(",");
    }
    if (enteredLatitude && !latitudehasError) {
      tenantToEdit.latitude = latitudeToAPI(enteredLatitude);
    }
    if (enteredLongitude && !longitudehasError) {
      tenantToEdit.longitude = longitudeToAPI(enteredLongitude);
    }
    const postData = { ...tenantToEdit, id: tenantId };
    const ifAnyValueChanged = Object.values(isUpdated.current).some(
      (value) => value === true
    );
    const needToCallEditTenantApi = Object.entries(isUpdated.current)
      .filter(([key, value]: [string, boolean]) => key !== "profilePic")
      .some(([key, value]: [string, boolean]) => value === true);
    const parameters1: any = {
      tenantId: tenantID,
      fileName: currentImage,
      progressBar: null,
    };

    // If no chnage in Edit Tenant fields, directly go to next Settings page
    // Else If there is change in image, call Upload Tenant Logo API
    // Else if there is change in Edit Tenant fields, call Edit Tenant API
    // Else if there is change in both Edit Tenant fields and image, call Edit Tenant API and then Upload Tenant Logo API

    if (!ifAnyValueChanged) {
      goToSettingsPage();
      return;
    } else if (!needToCallEditTenantApi) {
      setIsLoading(true);
      dispatch(uploadTenantLogoDetails(parameters1))
        .unwrap()
        .then(() => {
          goToSettingsPage();
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    } else if (isUpdated.current.profilePic === false) {
      setIsLoading(true);
      dispatch(editTenantDetails(postData))
        .unwrap()
        //// Earlier code will be as it is
        .then((response: any) => {
          setIsLoading(false);
          // setStepperState({
          //   ...stepperState,
          //   currentStep: "Settings",
          //   steps: stepperState.steps.map((step) => {
          //     if (step.id === "EditTenant") {
          //       return { ...step, status: "valid" };
          //     }
          //     return step;
          //   }),
          // });
          goToSettingsPage();
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error.error.response, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(true);
      dispatch(editTenantDetails(postData))
        .unwrap()
        .then(() => {
          dispatch(uploadTenantLogoDetails(parameters1))
            .unwrap()
            .then(() => {
              // setStepperState({
              //   ...stepperState,
              //   currentStep: "Settings",
              //   steps: stepperState.steps.map((step) => {
              //     if (step.id === "EditTenant") {
              //       return { ...step, status: "valid" };
              //     }
              //     return step;
              //   }),
              // });
              goToSettingsPage();
            })
            .catch((err) => {
              setErrorListGlobal((prevState) =>
                updateErrorList(err.error.response, [...prevState])
              );
            });
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error?.error?.response, [...prevState])
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  // istanbul ignore next
  // Handle validate
  const validate = () => {
    let temp = {
      custName: enteredTenantName,
      address1: enteredheadquarterAddress,
      timezone: enteredTimeZone,
      datacenter: enteredDatacenter,
      currency: enteredCurrency,
      tenantId: tenantID,
      country: "",
      region: enteredRegion,
      state: "",
    };
    temp.custName = enteredTenantName ? "" : "This field is required";
    temp.tenantId = tenantID ? "" : "This field is required";
    temp.address1 = enteredheadquarterAddress ? "" : "This field is required";
    temp.currency = enteredCurrency ? "" : "This field is required";
    temp.datacenter = enteredDatacenter ? "" : "This field is required";
    temp.timezone = enteredTimeZone ? "" : "This field is required";
    temp.region = enteredRegion ? "" : "This field is required";
    setErrors({ ...temp });
    //setCreateOpen(true);
    return Object.values(temp).every((x) => x === "");
  };
  // istanbul ignore next
  // to validate regex exp for input fields
  const validateData = () => {
    if (
      !validate() ||
      enteredProductSubmit.length === 0 ||
      AddresshasError ||
      tenanthasError
    ) {
      return;
    }
    // If form is valid and no value is updated, directly go to next Settings page
    else if (
      validate() &&
      Object.values(isUpdated.current).every((value) => value === false)
    ) {
      goToSettingsPage();
    } else {
      setCreateOpen(true);
    }
  };

  const confirmCancelHandller = () => {
    setCancelOpen(false);
    navigate("/tenant");
  };

  // istanbul ignore next
  //while updating image
  const ImageUpload: React.FC = () => {
    const selectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFiles = event.target.files as FileList;
      setCurrentImage(selectedFiles?.[0]);

      setPreviewImage(URL.createObjectURL(selectedFiles?.[0]));
      setProgress(0);
      // If image is updated , enable Update button
      isUpdated.current = { ...isUpdated.current, profilePic: true };
      setIsFormDataChanged(true);
    };
    return (
      <div>
        <Button size="regular" variant="secondary" onClick={handleIconClick}>
          Edit Photo
        </Button>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={selectImage}
          style={{ display: "none" }}
        />
        {currentImage && progress > 0 && (
          <div className="progress my-3">
            <div
              className="progress-bar progress-bar-info"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin={0}
              aria-valuemax={100}
              style={{ width: progress + "%", color: "red" }}
            >
              {progress}%
              <LinearProgress variant="determinate" value={progress} />
            </div>
          </div>
        )}
        {message && (
          <div className="alert alert-secondary mt-3" role="alert">
            {message}
          </div>
        )}
        {imageInfos.length > 0 && (
          <div className="card mt-3">
            <div className="card-header">List of Images</div>
            <ul className="list-group list-group-flush">
              {imageInfos.map((img, index) => (
                <li className="list-group-item" key={index}>
                  <p>
                    <a href={img.url}>{img.name}</a>
                  </p>
                  <img src={img.url} alt={img.name} height="80px" />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  // istanbul ignore next
  // to handle ToastBar Close
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  const [crumbs, setCrumbs] = useState([
    {
      id: "edit-tenant",
      label: "Home",
    },
  ]);

  /**To deselct the products/applications */
  // istanbul ignore next
  //for handelling on delete
  const onDelete = (productId: any) => () => {
    let newSelectedApplications = enteredProduct.filter(
      (application) => application.productId !== productId
    );

    setProduct(newSelectedApplications);
    setAllSelected(false);
    handleUpdateBtnDisable(
      productsConcatenatedInAsDefaultValue,
      newSelectedApplications?.sort()?.join("_"),
      "product"
    );
  };
  /**To render selected applicaton/product chips/tags with limit tag*/
  // istanbul ignore next
  //for handelling select all feature

  let chipStyle = {
    margin: "0 5px 5px 0",
    borderRadius: "4px",
    border: "1px solid F0F0F0",
    backgroundColor: "#FFF",
    boxShadow: "1px 1px 1px 0px rgba(0, 0, 0, 0.15)",
    fontWeight: "400",
  };
  const renderLimitedSelectedApplicationTags = () => {
    let firstTwoTags = [];
    firstTwoTags = enteredProduct.slice(0, 2).map((v: any) => (
      <Chip key={v.productId} className="theme-chip">
        {v.productName}
        <ChipRemove
          children=""
          onClick={onDelete(v.productId)}
          className="theme-chip-remove"
        />
      </Chip>
    ));
    return firstTwoTags.concat(
      <Chip
        className="theme-chip"
        key="limit"
        onClick={() => {
          setShowAll(true);
        }}
      >
        {`+${enteredProduct.length - 2}`}
      </Chip>
    );
  };

  /**To render all selected applications/products tags/chips */
  const renderAllSelectedApplicationTags = () => {
    return enteredProduct.map((v: any) => (
      <Chip key={v.productId} className="theme-chip">
        {v.productName}
        <ChipRemove
          children=""
          onClick={onDelete(v.productId)}
          className="theme-chip-remove"
        />
      </Chip>
    ));
  };

  return (
    <>
      <>
        <div className="form_logo_wrap text-center color-bg-img">
          <div className="form_logo_image color-bg-img-setup-tenant">
            {/* <img src={ProfileIcon} alt="Logo" /> */}

            {previewImage !== "" ? (
              <img src={previewImage} alt="Logo" className="" />
            ) : tenantCurrentLogo === "" ? (
              <img
                src={theme === "light" ? addLogo : DefaultProfileImgDark}
                alt="Logo"
                className=""
              />
            ) : (
              <img
                src={`data:image/jpeg;base64,${tenantCurrentLogo}`}
                alt="Logo"
                className=""
              />
            )}
          </div>
          <ImageUpload />

          {/* <Button size="regular" variant="secondary">
                  Add Photo
                </Button> */}
        </div>
        <div className="form_box">
          <h4>Profile Information</h4>
          <div className="form_row">
            <div className="form_col">
              <Label requiredText="*"> Tenant Name * </Label>
              <Input
                required={true}
                id="TenantName"
                className="tenant-name"
                placeholder="Tenant Name"
                size="regular"
                disabled={true}
                value={enteredTenantName}
                //onChange={TenantNameChangeHandler}
                maxLength={32}
                // {...((errors.custName !== "" || tenanthasError) && {
                //   error: true,
                //   helperText: tenanthasError
                //     ? "Tenant name can only contain alphabets"
                //     : "This is a required field",
                // })}
              />
            </div>

            <div className="form_col">
              <Label requiredText="*"> Headquarters Address * </Label>
              <Input
                className="headquarters-address"
                id="Headquarters-Address"
                placeholder="Headquarters Address"
                size="regular"
                maxLength={32}
                value={enteredheadquarterAddress}
                onChange={headquarterAddressChangeHandler}
                {...((errors.address1 !== "" || AddresshasError) && {
                  error: true,
                  helperText: AddresshasError
                    ? "Address can only contain letters, numbers, dots(.) hyphens(-) & comma(,)"
                    : "This is a required field",
                })}
              />
              {(AddresshasError || enteredheadquarterAddress === "") && (
                <ControlError>This is a required field</ControlError>
              )}
            </div>
            <div className="form_col">
              <Label>{t(localeKeyMap.organizationName)} <span className="text-muted"> - Optional</span></Label>
              <Input
                className="organization-name"
                id="Organization-Name"
                placeholder={t(localeKeyMap.organizationName)}
                size="regular"
                maxLength={120}
                value={enteredOrganizationName}
                onChange={organizationNameChangeHandler}
              />
            </div>
            <div className="form_col">
              <Label>{t(localeKeyMap.organizationId)} <span className="text-muted"> - Optional</span></Label>
              <Input
                className="organization-id"
                id="Organization-ID"
                placeholder={t(localeKeyMap.organizationId)}
                size="regular"
                maxLength={120}
                value={enteredOrganizationId}
                disabled={true}
                onChange={organizationIdChangeHandler}
              />
            </div>
            <div className="form_col">
              <Label requiredText="*"> Region *</Label>
              <Select
                className="dropdown_col"
                id="Region"
                key={`region-select-${enteredRegion}`}
                // defaultValue={Number(regionDefaultValue)}
                placeholder="Region"
                size="regular"
                data-testid="SelectRegion"
                value={+enteredRegion}
                //onBlur={enteredRegionBlurHandler}
                onChange={(event: any) => {       
                  regionChangeHandler(event);
                }}
                // Enable country field after selecting "Region" field

                {...(errors.region !== "" && (
                  <ControlError>This is a required field</ControlError>
                ))}
              >
                {regionMapping
                  ?.slice()
                  .sort((a, b) => a?.name?.localeCompare(b?.name))
                  .map((region) => {
                    return (
                      <SelectOption
                        key={region.id}
                        value={Number(region.id)}
                        label={region.name}
                      />
                    );
                  })}
              </Select>
            </div>
            <div className="form_col">
              <Label>Country <span className="text-muted"> - Optional</span></Label>
              <Tooltip
                title={isCountryDisabled ? "Please select a region first" : ""}
              >
                <Select
                  key={`country-select-${stateForDropDownCountryMapping}`}
                  id="Country"
                  className="dropdown_col"
                  placeholder="Country"
                  size="regular"
                  data-testid="SelectCountry"
                  disabled={isCountryDisabled}
                  defaultValue={countryDefaultValue ? +countryDefaultValue : 0}
                  value={Number(enteredCountry)}
                  onChange={(event) => {
                    countryChangeHandler(event);
                  }}
                  // {...((enteredCountryHasError ||
                  //   enteredCountrySubmitError) && {
                  //   error: true,
                  // })}
                >
                  {countryMapping
                    ?.slice()
                    .sort((a, b) => a?.name?.localeCompare(b?.name))
                    .map((country) => (
                      <SelectOption key={country.id} value={country.id} label={country.name} />
                    ))}
                </Select>
              </Tooltip>
            </div>
            {+enteredCountry === 1 && (
              <div className="form_col">
                      <Label>State <span className="text-muted"> - Optional</span></Label>
                <Tooltip
                  title={
                    isStateDisabled && enteredCountry === "1"
                      ? "Please select a country first"
                      : ""
                  }
                >
                  <Select
                    id="State"
                    className="dropdown_col"
                    key={`state-select-${stateForDropDownStateMapping}`}
                    placeholder="State"
                    size="regular"
                    disabled={isStateDisabled}
                    data-testid="SelectState"
                    defaultValue={+stateDefaultValue}
                    value={Number(enteredState)}
                    onChange={(event) => {
                      stateChangeHandler(event);
                    }}
                  >
                    {stateMapping
                      ?.slice()
                      .sort((a, b) => a?.name?.localeCompare(b?.name))
                      .map((state) => (
                        <SelectOption key={state.id} value={state.id} label={state.name} />
                      ))}
                  </Select>
                </Tooltip>
              </div>
            )}
            <div className="form_col">
              <Label> Zip Code</Label>
              <Input
                className="zip-code"
                id="Zip-Code"
                placeholder="Zip Code"
                value={enteredZipcode}
                size="regular"
                onChange={(Event: any) => {
                  //const event = NewEvent(Event);
                  ZipcodeChangeHandler(Event);
                }}
              />
              {zipcodehasError && enteredZipcode !== "" && (
                <ControlError>
                  Zipcode can only contain alphabets, numbers, hyphens(-) with
                  3-15 characters.{" "}
                </ControlError>
              )}
            </div>
            <div className="form_col">
              <Label className="mb-3">{t(localeKeyMap.streetAddress)} <span className="text-muted"> - Optional</span></Label>
              <Input
                className="streetAddress"
                id="streetAddress"
                placeholder={t(localeKeyMap.streetAddress)}
                value={enteredStreet}
                size="regular"
                onChange={(Event: any) => { StreetAddressChangeHandler(Event); }}
              />
            </div>
            <div className="form_col">
              <Label className="mb-3">{t(localeKeyMap.city)} <span className="text-muted"> - Optional</span></Label>
              <Input
                className="city"
                id="city"
                placeholder={t(localeKeyMap.city)}
                value={enteredCity}
                size="regular"
                onChange={(Event: any) => { CityChangeHandler(Event); }}
              />
            </div>
            <div className="form_col">
              <Label className="mb-3">{t(localeKeyMap.latitude)} <span className="text-muted"> - Optional</span></Label>
              <Input
                className="latitude"
                id="latitude"
                placeholder={t(localeKeyMap.latitude)}
                value={enteredLatitude}
                size="regular"
                onChange={(Event: any) => { LatitudeChangeHandler(Event); }}
              />
              {latitudehasError && enteredLatitude !== "" && (
                <ControlError>{t(localeKeyMap.latitudeHelperText)}</ControlError>
              )}
            </div>
            <div className="form_col">
              <Label className="mb-3">{t(localeKeyMap.longitude)}<span className="text-muted"> - Optional</span></Label>
              <Input
                className="longitude"
                id="longitude"
                placeholder={t(localeKeyMap.longitude)}
                value={enteredLongitude}
                size="regular"
                onChange={(Event: any) => { LongitudeChangeHandler(Event); }}
              />
              {longitudehasError && enteredLongitude !== "" && (
                <ControlError>{t(localeKeyMap.longitudeHelperText)}</ControlError>
              )}
            </div>
          </div>
          <h4 className="other_info_title">Other Information</h4>
          <div className="form_row">
            <div className="form_col">
              <Label requiredText="*"> Tenant ID * </Label>
              <Input
                className="tenant-id"
                id="Tenant-ID"
                placeholder="Tenant ID"
                size="regular"
                disabled={true}
                value={tenantID}
                maxLength={32}
                // onChange={(event: any) => {
                //   ForgeIdChangeHandler(event);
                // }}
                // {...(errors.tenantId !== "" && {
                //   error: true,
                //   helperText: "This is a required field",
                // })}
              />
            </div>
            <div className="form_col">
              <Label requiredText="*"> Tenant Currency * </Label>
              <Select
                key={`currency-select-${enteredCurrency}`}
                id="Tenant-Currency"
                className="dropdown_col"
                placeholder="Tenant Currency"
                size="regular"
                value={+enteredCurrency}
                data-testid="SelectCurrency"
                onChange={(event) => {
                  currencyChangeHandler(event);
                }}
              >
                {optionsCurrency
                  ?.slice()
                  .sort((a, b) => a?.name?.localeCompare(b?.name))
                  .map((currency) => (
                    <SelectOption key={currency.id} value={currency.id} label={currency.name} />
                  ))}
              </Select>
              {errors.currency !== "" && (
                <ControlError>This is a required field </ControlError>
              )}
            </div>
            <div className="form_col">
              <Label requiredText="*"> Tenant Data Center * </Label>
              <Select
                className="dropdown_col"
                key={`datacenter-select-${enteredDatacenter}`}
                id="Tenant-Data-Center"
                placeholder="Tenant Data Center"
                data-testid="SelectDataCenter"
                // defaultValue={
                //   dataCenterDefaultValue ? +dataCenterDefaultValue : 0
                // }
                {...(errors.datacenter !== "" && {
                  error: true,
                })}
                value={+enteredDatacenter}
                size="regular"
                // onBlur={enteredDatacenterBlurHandler}
                onChange={(event) => {
                  // event.preventDefault();
                  dataCenterChangeHandler(event);
                }}
              >
                {optionsDataCenter
                  ?.slice()
                  .sort((a, b) => a?.name?.localeCompare(b?.name))
                  .map((dataCenter) => (
                    <SelectOption key={dataCenter.id} value={dataCenter.id} label={dataCenter.name} />
                  ))}
              </Select>
              {errors.datacenter !== "" && (
                <ControlError>This is a required field</ControlError>
              )}
            </div>
            <div className="form_col">
              <Label requiredText="*"> Time Zone * </Label>
              <Tooltip
                title={isTimeZoneDisabled ? "Please select a region first" : ""}
              >
                <Select
                  className="dropdown_col"
                  id="Tenant-TimeZone"
                  key={`timezone-select-${stateForDropDownTimeZoneMapping}`}
                  placeholder="Tenant Time Zone"
                  data-testid="SelectTimeZone"
                  disabled={isTimeZoneDisabled}
                  defaultValue={
                    timezoneDefaultValue ? timezoneDefaultValue : ""
                  }
                  // value={enteredTimeZone}
                  size="regular"
                  // onBlur={enteredTimeZoneBlurHandler}
                  onChange={(event: any) => {
                    TimezoneChangeHandler(event);
                  }}
                >
                  {TimezoneMapping
                    ?.slice()
                    .sort((a, b) => a?.name?.localeCompare(b?.name))
                    .map((timeZone) => (
                      <SelectOption key={timeZone.id} value={timeZone.id} label={timeZone.name} />
                    ))}
                </Select>
              </Tooltip>
              {enteredTimeZone === "" && (
                <ControlError>This is a required field</ControlError>
              )}
              {/* 19 Feb Undo this change */}
              {/* {(enteredTimeZoneHasError || enteredTimeZoneSubmitError) && (
                      <ControlError className={"requiredText"}>
                        This is a required field{" "}
                      </ControlError> 
                     )} */}
            </div>
            <div className="form_col">
              <Label requiredText="*"> Select Product * </Label>
              <Autocomplete
                data-testid="SelectProduct"
                className={`multiselect-dropdown ${
                  enteredProduct.length === 0 && "disabled"
                }`}
                multiple
                id="checkboxes-tags-demo"
                options={[
                  ...optionsProduct.filter(option => option.productName === SELECT_ALL_PRODUCT),
                  ...optionsProduct
                    .filter(option => option.productName !== SELECT_ALL_PRODUCT)
                    .slice()
                    .sort((a, b) => a.productName.localeCompare(b.productName))
                ]}
                value={enteredProduct}
                disableCloseOnSelect
                getOptionLabel={(option) => option.productName}
                onChange={handleApplicationSelection}
                renderTags={() => null}
                renderOption={(
                  props,
                  option: OptionsProduct,
                  { selected }: AutocompleteRenderOptionState
                ) => {
                  // CID 3328949:
                  if (option !== null && option !== undefined) {
                    const selectAllProps =
                      option.productId === SELECT_ALL_PRODUCT
                        ? { checked: allSelected }
                        : {};
                    return (
                      !allSelected && (
                        <li {...props}>
                          <Checkbox
                            className="dropdown"
                            icon={icon}
                            checkedIcon={checkedIcon}
                            checked={selected}
                            {...selectAllProps}
                          />
                          {option.productName}
                        </li>
                      )
                    );
                  }
                  return null;
                }}
                renderInput={(params) => (
                  <TextField
                    autoComplete={"off"}
                    placeholder={
                      enteredProduct.length === 0 ? "Select Product" : ""
                    }
                    sx={{
                      "& .MuiFormHelperText-root": {
                        marginTop: 0.1,
                        lineHeight: 0.9,
                      },
                      "& .MuiAutocomplete-root .MuiInputBase-input": {
                        height: "2rem",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "700",
                        opacity: "1",
                      },
                    }}
                    {...(enteredProductSubmit.length === 0 &&
                      true && {
                        error: true,
                      })}
                    {...params}
                  />
                )}
              />
              {enteredProductSubmit.length === 0 && (
                <ControlError>This is a required field</ControlError>
              )}
              <Box
                sx={{
                  marginTop: "5px",
                }}
              >
                {!showAll
                  ? enteredProduct.length > 2
                    ? renderLimitedSelectedApplicationTags()
                    : renderAllSelectedApplicationTags()
                  : renderAllSelectedApplicationTags()}
              </Box>
            </div>
            <div className="form_col">
              <Label className="mb-3" requiredText="*">
                {t(localeKeyMap.selectUtilityTypeLabel)} *
              </Label>
              <Autocomplete
                data-testid="SelectUtilityType"
                className={`multiselect-dropdown`}
                multiple
                id="checkboxes-utility-types"
                options={[
                  ...optionsUtilityType.filter(option => option.name === SELECT_ALL_PRODUCT),
                  ...optionsUtilityType
                    .filter(option => option.name !== SELECT_ALL_PRODUCT)
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                ]}
                value={enteredUtilityType}
                disableCloseOnSelect
                getOptionLabel={(option) => option.name}
                onChange={handleUtilityTypeSelection}
                renderTags={() => null}
                renderOption={(props, option: OptionsUtilityType, { selected }: AutocompleteRenderOptionState) => {
                  if (!option) return null;
                  const selectAllProps = option.name === SELECT_ALL_PRODUCT ? { checked: allSelectedUT } : {};
                  return (
                    !allSelectedUT && (
                      <li {...props}>
                        <Checkbox
                          className="dropdown"
                          icon={icon}
                          checkedIcon={checkedIcon}
                          checked={selected}
                          {...selectAllProps}
                        />
                        {option.name}
                      </li>
                    )
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    autoComplete={"off"}
                    placeholder={enteredUtilityType.length === 0 ? t(localeKeyMap.selectUtilityTypeLabel) : ""}
                    sx={{
                      "& .MuiFormHelperText-root": { marginTop: 0.1, lineHeight: 0.9 },
                      "& .MuiAutocomplete-root .MuiInputBase-input": { height: "2rem" },
                      "& .MuiInputBase-input::placeholder": { color: "#000", fontSize: "14px", fontWeight: "700", opacity: "1" },
                    }}
                    {...(enteredUtilityTypeSubmit.length === 0 && true && { error: true })}
                    {...params}
                  />
                )}
              />
              {enteredUtilityTypeSubmit.length === 0 && (
                <ControlError>{t(localeKeyMap.requiredField)}</ControlError>
              )}
              <Box sx={{ marginTop: "5px" }}>
                {!showAllUT
                  ? enteredUtilityType.length > 3
                    ? renderLimitedSelectedUtilityTypeTags()
                    : renderAllSelectedUtilityTypeTags()
                  : renderAllSelectedUtilityTypeTags()}
              </Box>
            </div>
          </div>
        </div>

        <Footer
          //   #TODO cancelButtonRequired={tenantDetails?.status === "SetupCompleted"}
          // disabling as of now since we not sure with states after updating a setting
          cancelButtonRequired={false}
          openDialogCreate={createOpen}
          setOpenDialogCreate={setCreateOpen}
          openDialogCreateHeading="Edit Tenant"
          openDialogCreateContent="Do you want to update this tenant?"
          openDialogonClose={false}
          openDialogCancel={false}
          dialogCreatePrimaryBtnLabel="Confirm"
          dialogCreateSecondaryBtnLabel="Cancel"
          setOpenDialogCancel={function (value: boolean): void {}}
          onBackBtn={onBackBtn}
          cancelBtnLabel="Cancel"
          createBtnLabel="Next"
          checkIfAnyTextFilled={checkIfAnyTextFilled}
          onSubmit={onSubmitHandeller}
          validate={validateData}
        />

        {/* ///////////////// New Footer End ////////////// */}
        {/* Footer end */}
      </>
      <div>
        <ErrorHandlingComponent
          openToast={openToastError}
          onCloseToast={handleToastBarClose}
          errorList={errorListGlobal.concat(toastErrors.current)}
          openServerError={openDialogServerError}
          onCloseServerError={onDialogForServerCloseHandler}
          openNoURL={openDialogNoURLError}
          onCloseNoURL={onDialogForNOURLCloseHandler}
          openDialogforConflict={openDialogforConflict}
          onCloseServerConflictError={onDialogForConflictCloseHandler}
        />
      </div>
    </>
  );
};
function checkIfValueCHanged(defaultValue: string, newValue: string) {
  if (defaultValue === newValue) {
    return false;
  } else {
    return true;
  }
}

export default CreateEditTenantonBack;

const NewEvent = (event: any) => {
  const newEvent = {
    target: {
      value: event
        .filter((x: { selected: boolean }) => x.selected === true)
        .map((y: { value: any }) => y.value)[0],
    },
  };
  return newEvent;
};
